<template>
  <div class="row">
    <div class="col-12">
      <page-header />
      <div class="row">
        <div class="col-12 main-content">
          <data-table
            v-model="table"
            :get-page="getPage"
            :per-page="250"
            :selectable-rows="true"
          >
            <template #head(company)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.company"
                input-type="number"
              />
            </template>
            <template #head(keyword)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.keyword" />
            </template>
            <template #head(subKeywordId)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.subKeywordId"
                input-type="number"
              />
            </template>
            <template #head(sortingVariant1)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.sortingVariant1"
                input-type="number"
              />
            </template>
            <template #head(sortingVariant2)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.sortingVariant2"
                input-type="number"
              />
            </template>
            <template #head(sortingVariant3)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.sortingVariant3"
                input-type="number"
              />
            </template>
            <template #head(sortingVariant4)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.sortingVariant4"
                input-type="number"
              />
            </template>
            <template #head(sortingVariant5)="row">
              {{ row.label }}
              <table-filter
                v-model="table.filter.sortingVariant5"
                input-type="number"
              />
            </template>
            <template #head(primaryKey)="row">
              {{ row.label }}
              <table-filter v-model="table.filter.primaryKey" />
            </template>
          </data-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '../../table/data-table';
import { NotificationMixin, ArticleMixin } from '../../../mixins';
import TableFilter from '../../table/table-filter';
import PageHeader from '../../structure/page-header';

export default {
  name: 'ArticleKeywordStructure',
  components: { PageHeader, DataTable, TableFilter },
  mixins: [NotificationMixin, ArticleMixin],
  data: function() {
    return {
      table: {
        selectedRow: null,
        rows: [],
        fields: [
          { key: 'company', label: this.$translate('company') },
          { key: 'keyword', label: this.$translate('keyword_id') },
          { key: 'subKeywordId', label: this.$translate('sub_keyword_id') },
          {
            key: 'sortingVariant1',
            label: `${this.$translate('sorting_variant')} 1`,
          },
          {
            key: 'sortingVariant2',
            label: `${this.$translate('sorting_variant')} 2`,
          },
          {
            key: 'sortingVariant3',
            label: `${this.$translate('sorting_variant')} 3`,
          },
          {
            key: 'sortingVariant4',
            label: `${this.$translate('sorting_variant')} 4`,
          },
          {
            key: 'sortingVariant5',
            label: `${this.$translate('sorting_variant')} 5`,
          },
          { key: 'primaryKey', label: this.$translate('primary_key') },
        ],
        filter: {
          company: null,
          keyword: null,
          subKeywordId: null,
          sortingVariant1: null,
          sortingVariant2: null,
          sortingVariant3: null,
          sortingVariant4: null,
          sortingVariant5: null,
          primaryKey: null,
        },
      },
    };
  },
  methods: {
    async getPage(ctx) {
      try {
        const response = await this.articleService.getActicleKeywordStructures(
          ctx
        );
        return { totalCount: response.totalCount, data: response.data };
      } catch (err) {
        this.showNotification({ type: 'error', message: err.message });
      }
    },
  },
};
</script>
